import {PerformanceState} from '../../reducers/fortnite-game/performance.reducer';

export const getPerformanceState = (state): PerformanceState => {
    return state.get('performance').toJS();
};
